export default "/Frontend/dist/arrow-rounded.7d153b90c2a8121a4f4492d3b202ec5f.svg";